import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Thème avant le premier rendu (évite le flash) : sombre par défaut,
// "light" si l'utilisateur l'a choisi. Stockage local, par navigateur.
try {
  if (localStorage.getItem('bo-theme') === 'light') {
    document.documentElement.classList.add('light');
  }
} catch {
  /* stockage indisponible : reste en sombre */
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
